module.exports = __webpack_public_path__ + "img/thumbnail-2.d3738b11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thumbnail-2.jpg
// module id = V6WZ
// module chunks = 1